// Taşeron portalı — Supplier Panosu (api-contract §28) gün/saat biçimleyicileri.
//
// §28 girişi NORMATİF: istemci tarihleri yanıtın `asOf` (UTC anı) + `timezone` (IANA,
// sunucunun günü kestiği zon) alanlarıyla hesaplar — CİHAZ zon'uyla DEĞİL (aksi hâlde
// switcher rozeti ile panonun kendisi ayrışır; plan S26 "Bilinen tuzaklar").
//
// Panel rebuild (owner tasarım değişikliği) — 7 günlük görünüm (RiskWeekCard) kalktı; bu
// dosyanın o karta özgü mutlak gün+saat biçimleyicileri (`formatDayLabel`,
// `formatAbsoluteDayTime`) onunla birlikte SİLİNDİ. "Aktif Çalışma İzinleri" panosu A/B
// karşılaştırmasını (2026-08-16) TABLO kazandı (owner kararı) — tablo geçerlilik ARALIĞINI
// simetrik, HER İKİ ucu da MUTLAK tarihle gösterir (`absoluteDayLabel`), "bugün"/"yarın"
// GÖRECELİ etiketi ARTIK HİÇBİR yerde kullanılmıyor. `relativeDayTime`/`dayOffsetFromAsOf`
// ve onların özel yardımcıları (`calendarDayKey`, `dateKeyToUtcNoon`) bu yüzden SİLİNDİ —
// tek çağıranları (`UpcomingPermitsCard.tsx`'in eski relatif başlık etiketi) artık YOK.
// Geri gerekirse git geçmişinde durur, İCAT ETMEDEN kopyalanabilir.

/** Yanıtın tepesindeki saat referansı (§28 girişi) — tüm gün aritmetiği bununla yapılır. */
export interface DashboardClock {
  /** UTC ISO 8601 — sunucunun hesap anı. */
  asOf: string;
  /** IANA — istemci gün aritmetiğini BUNUNLA yapar. */
  timezone: string;
}

/** HH:mm — `timezone`'da. `CompanySwitcher.tsx`'in kesim saati etiketi için. */
export function formatTime(iso: string, timezone: string, culture: string): string {
  return new Intl.DateTimeFormat(culture, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone,
  }).format(new Date(iso));
}

/**
 * Salt tarih (gün + kısa ay), `timezone`'da — HER ZAMAN mutlak, "bugün/yarın" GÖRECELİLİĞİ
 * YOK. `UpcomingPermitsCard.tsx`'in (tablo tasarımı, owner A/B kararı) geçerlilik ARALIĞI
 * sütunu bunu HEM başlangıç HEM bitiş için kullanır — iki uç SİMETRİK aynı biçimde (owner
 * isteği, 2026-08-16 dördüncü tur: "yarın 15:00" gibi göreceli/saatli bir başlangıç, mutlak
 * bir bitişin yanında karışık rejim okunuyordu).
 */
export function absoluteDayLabel(iso: string, timezone: string, culture: string): string {
  return new Intl.DateTimeFormat(culture, {
    day: 'numeric',
    month: 'short',
    timeZone: timezone,
  }).format(new Date(iso));
}
